// Every timestamp in the DB is stored in UTC (SYSUTCDATETIME()). The portal is used from Vietnam,
// so display and "today" logic are pinned to Asia/Ho_Chi_Minh instead of the viewer's machine —
// a user in Korea must see the same wall-clock time as the factory floor.
//
// Do NOT format timestamps with toISOString(): it always renders UTC, which showed a 09:36
// Vietnam request as "02:36". And do NOT derive "today" from toISOString() either: at 09:00 in
// Vietnam that string is still the previous UTC day, which silently shifted D-day and Overdue.
export const VN_TZ = 'Asia/Ho_Chi_Minh';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const partsOf = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: VN_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
  // en-GB gives 24-hour time but renders midnight as "24"
  if (parts.hour === '24') parts.hour = '00';
  return parts;
};

/** 'YYYY-MM-DD HH:mm' in Vietnam time, or the fallback when the value is empty/invalid. */
export const fmtDateTimeVN = (value, fallback = '—') => {
  if (!value) return fallback;
  const p = partsOf(value);
  if (!p) return fallback;
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
};

/** 'YYYY-MM-DD HH:mm:ss' in Vietnam time. */
export const fmtDateTimeSecVN = (value, fallback = '—') => {
  if (!value) return fallback;
  const p = partsOf(value);
  if (!p) return fallback;
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
};

/**
 * 'YYYY-MM-DD' in Vietnam time. A value that is already a plain date (no time part) is returned
 * untouched — converting it would only risk shifting the day.
 */
export const fmtDateVN = (value, fallback = '—') => {
  if (!value) return fallback;
  if (typeof value === 'string' && DATE_ONLY.test(value.trim())) return value.trim();
  const p = partsOf(value);
  if (!p) return fallback;
  return `${p.year}-${p.month}-${p.day}`;
};

/** Today's date in Vietnam as 'YYYY-MM-DD' — use this for every date comparison. */
export const todayVN = () => {
  const p = partsOf(new Date());
  return `${p.year}-${p.month}-${p.day}`;
};
